/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of carts (patients) to display or load carts */


(function () {
  'use strict';
  angular.module('vcfinance.cart')
    .component('cartlist', {
      restrict: 'E',
      bindings: {
        clientid: '<'
      },
      template: `
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Bezeichnung</th>
            <th>Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="cart in vm.carts">
            <td>{{cart.name}}</td>
            <td>
              <button class="btn btn-primary" ng-click="vm.editCart(cart)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>
              <button class="btn btn-danger" ng-click="vm.removeCart(cart)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>
            </td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Cart', 'CartHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Cart, CartHelper, vertxEventBusService) {
          let vm = this;
          vm.editCart = CartHelper.editCart;
          vm.removeCart = removeCart;

          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              if (angular.isDefined(changes.clientid)) {
                vm.clientid = changes.clientid.currentValue;
                // Cart.$getCart({clientid: vm.clientid}).$then(function (carts) {
                Cart.$getCart(vm.clientid).$then(function (carts) {
                  vm.cart = carts[0];
                }, function (err) {
                  $log.error('cart search by foreign id failed, clientid: ', vm.clientid);
                  Rlog.error('cart', 'cartlist', 'cart search by foreign id failed', {
                    clientid: vm.clientid
                  });
                });
              }
            }
          };


          function removeCart(cart) {
            cart.active = false;
            cart.$save();
          }

          vertxEventBusService.on('carts.update', function (message) {
            $log.debug('debug: cart update received: ', message);
            let messages = message.split(':');
            vm.carts.$refresh().$then(function () {
              $log.debug('debug: cartlist refreshed carts');
            }, function (error) {
              $log.debug('debug: cartlist refresh carts failed: ', error);
            });
          });


        }] // controller
    }); // component

  // klammerfriedhof
}());